import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roleSelect", "organizationSection", "brandSection"]
  static values = {
    organizationManagerRoleId: String,
    brandManagerRoleId: String
  }

  connect() {
    this.toggle(this.organizationSectionTarget, false)
    this.toggle(this.brandSectionTarget, false)

    if (this.hasRoleSelectTarget) {
      this.roleSelectTarget.addEventListener('change', () => {
        setTimeout(() => this.updateVisibility(), 50)
      })
      
      const checkTomSelect = (attempts = 0) => {
        const tomSelect = this.roleSelectTarget.tomselect
        if (tomSelect) {
          tomSelect.on('change', () => {
            setTimeout(() => this.updateVisibility(), 50)
          })
          
          this.updateVisibility()
        } else if (attempts < 10) {
          setTimeout(() => checkTomSelect(attempts + 1), 100)
        } else {
          this.updateVisibility()
        }
      }
      
      setTimeout(() => checkTomSelect(), 100)
    }
  }

  onChange() {
    this.updateVisibility()
  }

  updateVisibility() {
    if (!this.hasRoleSelectTarget) return

    let roleId = ""
    
    if (this.roleSelectTarget.tomselect) {
      const value = this.roleSelectTarget.tomselect.getValue()
      roleId = Array.isArray(value) ? (value[0] || "") : (value || "")
    }
    
    if (!roleId) {
      roleId = this.roleSelectTarget.value || ""
    }

    if (!roleId && this.roleSelectTarget.selectedOptions && this.roleSelectTarget.selectedOptions.length > 0) {
      roleId = this.roleSelectTarget.selectedOptions[0].value || ""
    }

    const isOrganizationManager = roleId && this.organizationManagerRoleIdValue && roleId === this.organizationManagerRoleIdValue
    const isBrandManager = roleId && this.brandManagerRoleIdValue && roleId === this.brandManagerRoleIdValue

    this.toggle(this.organizationSectionTarget, isOrganizationManager)
    
    this.toggle(this.brandSectionTarget, isBrandManager)
  }

  toggle(element, show) {
    if (!element) return
    element.style.display = show ? "block" : "none"
  }
}

